import './App.scss';
import Routing from './Routing';
import { useSelector, useDispatch } from 'react-redux';
import { toolKitReleased, toolKitMove } from './redux/actions/index';

function App() {
  const toolKit = useSelector(state => state.toolKit);
  const dispatch = useDispatch()
  const toolKitReleaseD = () => {
    dispatch(toolKitReleased());
  }
  const toolKitMovE = (x,y) => {
    dispatch(toolKitMove(x,y));
  }
  return (
    <div className = {toolKit.dragFlag? "App drag" : "App"}
    onMouseUp={()=>{ toolKitReleaseD() }}
    onMouseLeave={()=>{ toolKitReleaseD() }}
    onMouseMove={(e)=>{
      if(toolKit.dragFlag)  toolKitMovE(e.movementX, e.movementY)
    }}>
      <Routing />
    </div>
  );
}

export default App;
